<template>
    <div class="prices">
        <template
            v-for="(product, key) in products"
            :key="`product-${key}`"
        >
            <button
                class="price"
                :class="{
                    'bundle': renderDescription(),
                }"
                @click="$emit('addProduct', product)"
            >
                <div v-if="product.attributes?.discount" class="save">
                    <span class="bold">{{ $t('products.save') }}</span> {{ $cms.formatPrice(product.attributes?.discount) }}
                </div>
                <div class="price-details">
                    <div
                        v-if="!renderDescription()"
                        class="price-amount"
                    >
                        {{ getAmount(product) }} {{ $t('products.pcs') }}
                    </div>
                    <div class="price-price">
                        {{ $cms.formatPrice(product.attributes?.price) }}
                    </div>
                </div>
                <div class="buy">{{ $t('products.buy') }}</div>
            </button>
            <div
                v-if="renderDescription()"
                class="bundle-description"
            >
                <h3 class="h5">{{ $t('bundleContains') }}:</h3>
                <span
                    v-for="(bundle, bKey) in product.bundleMembers"
                    :key="`bundle-${key}-${bKey}`"
                >
                    {{ bundle.amount ?? 1 }} {{ $t('pcs') }} {{ bundle.product?.globalName }}
                </span>
            </div>
        </template>
    </div>
</template>
<script setup>
import { useI18n } from '#imports';

const props = defineProps({
    products: {
        type: Array,
        default: () => [],
    },
});

useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            bundleContains: 'Pesupaketti sisältää',
            pcs: 'kpl',
        },
    },
});

defineEmits(['addProduct']);

function renderDescription() {
    if (props.products.filter(item => item.isBundle === true).length === props.products.length) {
        return true;
    }

    return false;
}

function getAmount(product) {
    if (product.isBundle && product.bundleMembers?.length === 1) {
        return product.bundleMembers[0]?.amount;
    }

    return 1;
}
</script>

<style scoped>
.prices {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.125rem;
  text-align: center;
  overflow: hidden;
  margin-top: 0.5rem;
  align-items: end;
}
.prices .price {
  width: 100%;
  display: grid;
  align-items: end;
  font-weight: 700;
  grid-template-rows: 0.6fr auto 1fr;
  cursor: pointer;
}
.prices .price .save {
  justify-self: end;
  width: 100%;
  background-color: var(--color-error-500);
  color: var(--color-base-white);
  font-size: 0.75rem;
  line-height: 1;
  padding: 0.25rem;
}
.prices .price .price-details {
  background-color: var(--color-base-grey-100);
  height: 4rem;
  display: grid;
  grid-row-start: 2;
  align-items: center;
}
.prices .price .price-details .price-amount {
  font-weight: 400;
  font-size: 0.875rem;
  margin-bottom: -1.25rem;
}
.prices .price .buy {
  grid-row-start: 3;
  background-color: var(--color-primary-800);
  height: 2rem;
  display: grid;
  align-items: center;
  align-self: baseline;
}
.prices .price:hover .buy {
  background-color: var(--color-primary-700);
}
.prices .price:last-child .save {
  border-radius: 0 0.275rem 0 0;
}
.prices .price:last-child .buy {
  border-radius: 0 0 0.275rem;
}
.prices .price:first-child .save {
  border-radius: 0.275rem 0 0;
}
.prices .price:first-child .buy {
  border-radius: 0 0 0 0.275rem;
}
.prices .price.bundle .save, .prices .price:first-child:last-child .save {
  border-radius: 0.275rem 0.275rem 0 0;
}
.prices .price.bundle .buy, .prices .price:first-child:last-child .buy {
  border-radius: 0 0 0.275rem 0.275rem;
}
.prices .bundle-description {
  margin-top: 1rem;
  padding: 0 0 0 1.5rem;
  grid-column-end: span 2;
  justify-content: start;
  align-self: center;
  align-items: start;
  text-align: left;
}
.prices .bundle-description .h5 {
  margin-bottom: 0.5rem;
}
.prices .bundle-description span {
  display: block;
  font-weight: 600;
}
.prices .bundle-description span:not(:last-child) {
  margin-bottom: 0.5rem;
}
.prices .bold {
  font-weight: 600;
}

.description {
  display: none;
}

.info {
  display: none;
}
</style>
